import Layout from "../components/Layouts";
import Nav from "../components/Navi";
import Footer from "../components/Footers";
import CountdownBar from "../components/CountdownBar";
import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
export default function Cookie() {
  const { t } = useTranslation("common");
  return (
    <>
    <section className="page-default">
      <div className="container en mt-5">
        <h1>Cookie Notice for Hayya Media Portal </h1>
        <p>
          This Cookie Notice explains how the Supreme Committee for Delivery &
          Legacy (<strong>SC</strong>, <strong>we</strong>, <strong>us</strong>)
          uses cookies and other similar technologies on the Hayya website and Hayya Media Portal(HMP), 
          the website offering a unique, single source of information to 
          Media, through which Media can have access to a
          selection of services, including, but not limited to, obtaining accreditation and/or permits to cover a given event and have access to media content and services
          and which is hosted at &nbsp;
          <a href="/" target="_blank">
            http://media.hayya.qa/
          </a>{" "}
          (the <strong>Platform</strong>).
        </p>
        <p>
          This Cookie Notice explains the types of Cookies we use and why. It
          also explains how you can change your Cookie preferences.
        </p>
        <p>
          You should read this Cookie Notice alongside our Terms of Use <a href="/terms" target="_blank">
             https://media.hayya.qa/terms
          </a>{" "}
          and our Privacy Policy&nbsp;
          <a href="/privacy-policy" target="_blank">
            https://media.hayya.qa/privacy-policy
          </a>
          .
        </p>

        <h3>1. What are cookies and other tracking technologies?</h3>
        <p>
          Cookies are small piece of data (alphanumeric files) that are placed
          on your device when you visit websites. They are commonly used to make
          websites work, or work more efficiently, as well as to provide
          information about your use of the website and display content and
          advertising that is relevant to you. Other, similar, technologies can
          also be used to achieve these outcomes. This could include, for
          example, SDK tools (which are used on mobile apps), tracking pixels,
          advertising IDs, social media plug-ins, HTML local storage, Local
          Shared Objects and device fingerprinting techniques. In this Cookie
          Notice, we will use the term “<strong>Cookies</strong>” to refer to
          both cookies and similar technologies.
        </p>
        <h3>2. Why do we use Cookies?</h3>
        <p>
          We use Cookies for a variety of purposes. For example, to enable you
          navigate between webpages efficiently and to allow our Platforms to
          remember your preferences. Cookies can track browsing behaviour to
          help us to understand how our Platforms are used so that we can
          improve them. Cookies can also help ensure
          that any adverts that you see on our Platforms and other websites are
          more relevant to you and your interests.
        </p>
        <h3>
          3. What Cookies do we use and how long will they stay on my device?
        </h3>
        <p>
          Where we place Cookies on your device, these are called{" "}
          <strong>first party</strong> Cookies.
        </p>
        <p>
          We also use <strong>third party</strong> Cookies. These Cookies are
          set by third party domains and are set for analytics
        </p>
        <p>
          Some Cookies will stay on your device only for as long as you are
          accessing our Platforms during a single browsing session and so are
          temporary. These are known as <strong>session cookies</strong>. Other
          Cookies are stored on your device for longer periods to enable our
          Platforms to “remember” you and your preferences. These are known as
          &nbsp;
          <strong>persistent cookies</strong>.
        </p>
        <p>
          Some of the Cookies we use are strictly necessary for our Platforms to
          operate effectively. Others are not necessary but are used for a
          variety of purposes which are outlined in the text below.
        </p>
        <h3>
          <i>Strictly necessary Cookies</i>
        </h3>
        <p>
          These are Cookies which are essential for our Platforms to operate.
          For example, Cookies that are used to help a webpage load quickly.
        </p>
        <p>
          For a list of the strictly necessary Cookies we use please see Annex A
          hereto.
        </p>
        <h3>
          <i>Performance Cookies </i>
        </h3>
        <p>
          These Cookies help us to improve the way our website works. For
          example, they gather information that allows us to count the number of
          visitors to our Platform and to see how visitors move around our
          Platform.
        </p>
        <p>
          For a list of the performance Cookies we use on the Platform and why
          we use them, please see Annex A.
        </p>
        <h3>
          <i>Functionality Cookies / Social media</i>
        </h3>
        <p>
          These Cookies allow the Platforms to remember choices you have made
          such as your user name, language, the region you are in. They
          therefore provide a more enhanced and personalised experience.
        </p>
        <p>
          They also include social media plug-ins which enable you to share our
          Platform content via your social media account(s) or easily share
          information with others. Hayya has presence on Facebook, YouTube,
          Instagram, Twitter and LinkedIn. If you click on any of the Facebook,
          YouTube, Instagram, Twitter and LinkedIn icons on our website, you
          will be taken to our pages or profiles on those platforms. The
          platforms may then start tracking your behaviour using Cookies for
          their own purposes; for example, to better understand your interests
          so that they can present relevant content or advertising to you. Data
          about you may also be transmitted to the social media channel even if
          you don’t click on the plug-in. The social media platforms will
          provide us with statistical information, which we use to help
          understand how you and our other users interact with our social medial
          presence. All these platforms provide you with some control over their
          use of non-essential tracking technology and you can find details of
          how to exercise this control by reviewing their privacy and cookie
          notices. We have contractual arrangements in place with the social
          media channels we use. Please contact us for more information.
        </p>
        <p>
          For a list of the functionality Cookies we use the Platform please see
          Annex A.
        </p>
        <h3>
          <i>Targeting / Advertising Cookies</i>
        </h3>
        <p>
          These Cookies record information about your visit to our Platform to
          help target advertising and to build a profile of you. For example,
          the pages you have visited, the links you have followed, the number of
          times you’ve seen an ad, the ads you have clicked on and your browsing
          habits / interests.
        </p>
        <p>
          Our advertising partners use this information to make the ads you see
          both on and off our Platform more personalised and relevant to your
          interests. They may combine it with other information they have about
          you, for example information about your browsing habits on other
          websites or information they have obtained from third party data
          brokers. This will then be used to create a profile of you so that
          relevant advertising is shown to you. You might also see our
          advertisements on other websites that you visit.
        </p>
        <p>
          Targeting / Advertising Cookies may also be used for other purposes
          such as ad click fraud detection, market research, product improvement
          and debugging.
        </p>
        <p>
          For a list of the Targeting / Advertising Cookies we use and why we
          use them, please see Annex A.
        </p>
        <h3>
          <i>Our marketing emails</i>
        </h3>
        <p>
          Our marketing emails contain a campaign-unique “web pixel” to tell us
          how you interact with our communications. For example, whether you
          opened the email or clicked on a link in it. We use this information
          to help determine which of our emails are more interesting to you and
          to query if you should to continue receiving emails if you do not open
          them. In general, these pixels help us to understand how effective our
          marketing campaigns are and your level of engagement with us. The
          pixel will be deleted when you delete the email.
        </p>
        <p>
          If you do not wish the pixel to be downloaded to your device, you
          should opt-out of email marketing altogether or configure your email
          to not load remote images by default or view your emails in plaintext
          format.
        </p>
        <h3>
          <i>List-based targeting </i>
        </h3>
        <p>
          Sometimes we will use Cookies, or other identifiers such as your email
          address, to create a list of individuals who we would like to target
          advertising about our products and services to when those individuals
          use certain social media platforms. This type of list is often
          referred to as a “Custom Audience”. For more information about our use
          of this type of list based marketing and other similar tools, please
          visit our&nbsp;
          <a
            href="/privacy-policy"
            target="_blank"
            class="text-decoration-underline"
          >
            Privacy Policy
          </a>
          .
        </p>
        <h3>4. Changes to this Cookie Notice</h3>
        <p>
          We will inform you of any changes to this Cookie Notice by posting
          them on this page and updating the Cookie text above.
        </p>
        <p>
          This version of our Cookie Notice was uploaded on 24 October 2023.{" "}
        </p>
        <h3>5. Contact Us</h3>
        <p>
          If you have any further questions in relation to this Cookie Notice,
          please contact us at <a href="mailto:info@hayya.qa">info@hayya.qa</a>.
        </p>
        <h2 className="mt-5 pt-5 text-center">Annex A </h2>
        <h1 className=" text-center">Hayya Media Portal</h1>
        <h3 className="mt-5">
          <i>Strictly necessary Cookies</i>
        </h3>
        <table cellspacing="0" cellpadding="0" className="table table-bordered">
          <tbody>
            <tr>
              <td valign="middle">
                <p>
                  <strong>Cookie name </strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Purpose</strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Expiry period</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>access_token </p>
              </td>
              <td valign="middle">
                <p>Contains a token that can be used to retrieve data</p>
              </td>
              <td valign="middle">
                <p>2 hours to 1 week</p>
              </td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-5">
          <i>Performance Cookies</i>
        </h3>
        <table cellspacing="0" cellpadding="0" className="table table-bordered">
          <tbody>
            <tr>
              <td valign="middle">
                <p>
                  <strong>Cookie name </strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Purpose</strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Expiry period</strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Who places the Cookie?</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>_ga</p>
              </td>
              <td valign="middle">
                <p>
                  Registers a unique ID that is used to generate statistical
                  data on how the visitor uses the website.
                </p>
              </td>
              <td valign="middle">
                <p>2 years</p>
              </td>
              <td valign="middle">
                <p>
                  <a href="https://media.hayya.qa">
                    https://media.hayya.qa
                  </a>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>_gat</p>
              </td>
              <td valign="middle">
                <p>Used by Google Analytics to throttle request rate</p>
              </td>
              <td valign="middle">
                <p>1 day</p>
              </td>
              <td valign="middle">
                <p>
                  <a href="https://media.hayya.qa">
                    https://media.hayya.qa
                  </a>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>_gid</p>
              </td>
              <td valign="middle">
                <p>
                  Registers a unique ID that is used to generate statistical
                  data on how the visitor uses the website.
                </p>
              </td>
              <td valign="middle">
                <p>1 day</p>
              </td>
              <td valign="middle">
                <p>
                  <a href="https://media.hayya.qa">
                    https://media.hayya.qa
                  </a>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>collect</p>
              </td>
              <td valign="middle">
                <p>
                  Used to send data to Google Analytics about the visitor’s
                  device and behavior. Tracks the visitor across devices and
                  marketing channels.
                </p>
              </td>
              <td valign="middle">
                <p>Session</p>
              </td>
              <td valign="middle">
                <p>
                  <a href="https://media.hayya.qa">
                    https://media.hayya.qa
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-5">
          <i>Functionality Cookies / Social media</i>
        </h3>
        <table cellspacing="0" cellpadding="0" className="table table-bordered">
          <tbody>
            <tr>
              <td valign="middle">
                <p>
                  <strong>Cookie name </strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Purpose</strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Expiry period</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>N/A</p>
              </td>
              <td valign="middle">
                <p>N/A</p>
              </td>
              <td valign="middle">
                <p>N/A</p>
              </td>
            </tr>
          </tbody>
        </table>
        <h3 class="mt-5">
          <i>Targeting / Advertising Cookies</i>
        </h3>
        <table cellspacing="0" cellpadding="0" className="table table-bordered">
          <tbody>
            <tr>
              <td valign="middle">
                <p>
                  <strong>Cookie name and advertising partner</strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Purpose</strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Type of data collected</strong>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <strong>Expiry period</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>N/A</p>
              </td>
              <td valign="middle">
                <p>N/A</p>
              </td>
              <td valign="middle">
                <p>N/A</p>
              </td>
              <td valign="middle">
                <p>N/A</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    {/* <CountdownBar /> */}
    </>
  );
}

Cookie.getLayout = function getLayout(page) {
  return (
    <Layout>
      <Nav />
      {page}
      <Footer />
    </Layout>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
